import React, { useState, useEffect } from 'react';
import { getRuote, getIpotesi, createIpotesi, deleteIpotesi, rivalutaIpotesi, valutaNumeri } from '../services/api';

const Ipotesi = () => {
  const [ruote, setRuote] = useState([]);
  const [ipotesiList, setIpotesiList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [valutazione, setValutazione] = useState(null);
  
  // Form state
  const [nome, setNome] = useState('');
  const [origine, setOrigine] = useState('sogno');
  const [descrizione, setDescrizione] = useState('');
  const [numeriInput, setNumeriInput] = useState('');
  const [selectedRuote, setSelectedRuote] = useState([]);
  const [dataSogno, setDataSogno] = useState('');

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      const [ruoteRes, ipotesiRes] = await Promise.all([
        getRuote(),
        getIpotesi()
      ]);
      setRuote(ruoteRes.data);
      setIpotesiList(ipotesiRes.data);
    } catch (err) {
      console.error('Errore:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleValuta = async () => {
    const numeri = numeriInput.split(',').map(n => parseInt(n.trim())).filter(n => n >= 1 && n <= 90);
    if (numeri.length < 2) {
      alert('Inserisci almeno 2 numeri validi (1-90)');
      return;
    }
    
    try {
      const res = await valutaNumeri(numeri, selectedRuote.length > 0 ? selectedRuote : null);
      setValutazione(res.data);
    } catch (err) {
      alert('Errore nella valutazione');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const numeri = numeriInput.split(',').map(n => parseInt(n.trim())).filter(n => n >= 1 && n <= 90);
    if (numeri.length < 2) {
      alert('Inserisci almeno 2 numeri validi (1-90)');
      return;
    }

    try {
      await createIpotesi({
        nome: nome || null,
        origine,
        descrizione: descrizione || null,
        numeri,
        ruote: selectedRuote.length > 0 ? selectedRuote : null,
        data_sogno: dataSogno || null
      });
      
      // Reset form
      setNome('');
      setOrigine('sogno');
      setDescrizione('');
      setNumeriInput('');
      setSelectedRuote([]);
      setDataSogno('');
      setValutazione(null);
      setShowForm(false);
      
      loadData();
    } catch (err) {
      alert(err.response?.data?.detail || 'Errore nel salvataggio');
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Eliminare questa ipotesi?')) return;
    
    try {
      await deleteIpotesi(id);
      loadData();
    } catch (err) {
      alert('Errore eliminazione');
    }
  };

  const handleRivaluta = async (id) => {
    try {
      await rivalutaIpotesi(id);
      loadData();
    } catch (err) {
      alert('Errore rivalutazione');
    }
  };

  const toggleRuota = (ruotaId) => {
    setSelectedRuote(prev => 
      prev.includes(ruotaId) 
        ? prev.filter(r => r !== ruotaId)
        : [...prev, ruotaId]
    );
  };

  const getScoreColor = (score) => {
    if (score >= 70) return '#38a169';
    if (score >= 40) return '#d69e2e';
    return '#e53e3e';
  };

  if (loading) {
    return <div className="loading"><div className="spinner"></div></div>;
  }

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <h2>Ipotesi e Intuizioni</h2>
        <button className="btn btn-primary" onClick={() => setShowForm(!showForm)}>
          {showForm ? '✕ Chiudi' : '✨ Nuova Ipotesi'}
        </button>
      </div>

      {/* Form Nuova Ipotesi */}
      {showForm && (
        <div className="card" style={{ marginBottom: '20px' }}>
          <h3 className="card-title" style={{ marginBottom: '20px' }}>Nuova Ipotesi</h3>
          
          <form onSubmit={handleSubmit}>
            <div className="grid grid-2">
              <div className="form-group">
                <label className="form-label">Nome (opzionale)</label>
                <input
                  type="text"
                  className="form-input"
                  value={nome}
                  onChange={(e) => setNome(e.target.value)}
                  placeholder="Es: Sogno della nonna"
                />
              </div>
              
              <div className="form-group">
                <label className="form-label">Origine</label>
                <select
                  className="form-select"
                  value={origine}
                  onChange={(e) => setOrigine(e.target.value)}
                >
                  <option value="sogno">🌙 Sogno</option>
                  <option value="premonizione">✨ Premonizione</option>
                  <option value="intuizione">💡 Intuizione</option>
                  <option value="smorfia">📖 Smorfia</option>
                  <option value="altro">📝 Altro</option>
                </select>
              </div>
            </div>

            <div className="form-group">
              <label className="form-label">Numeri (separati da virgola)</label>
              <input
                type="text"
                className="form-input"
                value={numeriInput}
                onChange={(e) => setNumeriInput(e.target.value)}
                placeholder="Es: 7, 23, 45, 67"
                required
              />
            </div>

            <div className="form-group">
              <label className="form-label">Ruote (opzionale - clicca per selezionare)</label>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                {ruote.map((r) => (
                  <span
                    key={r.id}
                    className="ruota-badge"
                    style={{
                      cursor: 'pointer',
                      background: selectedRuote.includes(r.id) ? '#2c5282' : '#e2e8f0',
                      color: selectedRuote.includes(r.id) ? 'white' : '#4a5568'
                    }}
                    onClick={() => toggleRuota(r.id)}
                  >
                    {r.nome}
                  </span>
                ))}
              </div>
            </div>

            <div className="grid grid-2">
              <div className="form-group">
                <label className="form-label">Data sogno (opzionale)</label>
                <input
                  type="date"
                  className="form-input"
                  value={dataSogno}
                  onChange={(e) => setDataSogno(e.target.value)}
                />
              </div>
            </div>

            <div className="form-group">
              <label className="form-label">Descrizione (opzionale)</label>
              <textarea
                className="form-input"
                rows={3}
                value={descrizione}
                onChange={(e) => setDescrizione(e.target.value)}
                placeholder="Descrivi il sogno o l'intuizione..."
              />
            </div>

            {/* Pulsante Valuta */}
            <div style={{ marginBottom: '20px' }}>
              <button type="button" className="btn btn-secondary" onClick={handleValuta}>
                📊 Valuta Numeri
              </button>
            </div>

            {/* Risultato Valutazione */}
            {valutazione && (
              <div className="alert alert-info" style={{ marginBottom: '20px' }}>
                <strong>Score: </strong>
                <span style={{ color: getScoreColor(valutazione.score_totale), fontWeight: 'bold' }}>
                  {valutazione.score_totale}/100
                </span>
                <br />
                <span>{valutazione.consiglio}</span>
              </div>
            )}

            <div style={{ display: 'flex', gap: '10px' }}>
              <button type="submit" className="btn btn-primary">
                💾 Salva Ipotesi
              </button>
              <button type="button" className="btn btn-secondary" onClick={() => setShowForm(false)}>
                Annulla
              </button>
            </div>
          </form>
        </div>
      )}

      {/* Lista Ipotesi */}
      <div className="card">
        <h3 className="card-title" style={{ marginBottom: '20px' }}>Le tue Ipotesi</h3>
        
        {ipotesiList.length === 0 ? (
          <p style={{ color: '#718096', textAlign: 'center', padding: '20px' }}>
            Nessuna ipotesi salvata. Crea la tua prima ipotesi!
          </p>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
            {ipotesiList.map((ip) => (
              <div 
                key={ip.id} 
                style={{ 
                  border: '1px solid #e2e8f0', 
                  borderRadius: '8px', 
                  padding: '15px',
                  background: ip.convertita_in_giocata ? '#f7fafc' : 'white'
                }}
              >
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                  <div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
                      <strong>{ip.nome || `Ipotesi #${ip.id}`}</strong>
                      <span className="ruota-badge">{ip.origine}</span>
                      {ip.convertita_in_giocata && (
                        <span className="ruota-badge" style={{ background: '#c6f6d5', color: '#22543d' }}>
                          Convertita
                        </span>
                      )}
                    </div>
                    
                    <div style={{ marginBottom: '10px' }}>
                      {ip.numeri.map((n) => (
                        <span key={n} className="numero-ball small">{n}</span>
                      ))}
                    </div>
                    
                    {ip.ruote && ip.ruote.length > 0 && (
                      <div style={{ marginBottom: '10px' }}>
                        {ip.ruote.map((rId) => {
                          const ruota = ruote.find(r => r.id === rId);
                          return ruota ? (
                            <span key={rId} className="ruota-badge">{ruota.nome}</span>
                          ) : null;
                        })}
                      </div>
                    )}
                    
                    {ip.descrizione && (
                      <p style={{ color: '#718096', fontSize: '0.9rem', marginBottom: '10px' }}>
                        {ip.descrizione}
                      </p>
                    )}
                    
                    <div style={{ fontSize: '0.85rem', color: '#718096' }}>
                      Inserita il {new Date(ip.created_at).toLocaleDateString('it-IT')}
                    </div>
                  </div>
                  
                  <div style={{ textAlign: 'right' }}>
                    {ip.score !== null && (
                      <div style={{ marginBottom: '10px' }}>
                        <span style={{ 
                          fontSize: '1.5rem', 
                          fontWeight: 'bold',
                          color: getScoreColor(ip.score)
                        }}>
                          {ip.score}
                        </span>
                        <span style={{ color: '#718096' }}>/100</span>
                      </div>
                    )}
                    
                    <div style={{ display: 'flex', gap: '5px', justifyContent: 'flex-end' }}>
                      <button 
                        className="btn btn-secondary" 
                        style={{ padding: '5px 10px', fontSize: '0.8rem' }}
                        onClick={() => handleRivaluta(ip.id)}
                      >
                        🔄
                      </button>
                      <button 
                        className="btn btn-danger" 
                        style={{ padding: '5px 10px', fontSize: '0.8rem' }}
                        onClick={() => handleDelete(ip.id)}
                      >
                        🗑️
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Ipotesi;
